import React, { useEffect, useRef, useState } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import SliderWrapper from './_SlickSlider'
import { isEmpty } from 'lodash'
import EditMenu from '../editMenu'
import CustomImage from '../../customImage/customImage'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'

const ProductFaceCardCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const sliderRef = useRef(null)
  const { data, id } = componentData
  const { LeftArrow, RightArrow, getTemplateImage, customNavigate } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  useEffect(() => {
    if (data?.card_data?.length > 0 && sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0)
      }, 100)
    }
  }, [data?.card_data])

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          right: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={RightArrow}
          alt="Next"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          left: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={LeftArrow}
          alt="Previous"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  return (
    <div
      className={`w-full py-6 px-4  relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_color', 'component_color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div style={{ maxWidth: '1269px', margin: '0 auto' }}>
        <p
          style={{ color: getStyleValue('component_color', 'component_heading_color', '') }}
          className="text-xs md:text-sm lg:text-xl mb-8 font-semibold"
        >
          {data?.title}
        </p>
        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {data?.card_data?.map((item, index) => (
              <div key={index} className="relative group cursor-pointer">
                <div className="px-2" onClick={() => handleRedirect(item.link)}>
                  {/* Image Container */}
                  <div className="relative" style={{ aspectRatio: '1/1' }}>
                    <CustomImage
                      imageUrl={getTemplateImage(item?.image_s3key)}
                      imgAlt={item?.card_heading}
                      imgClass="w-full h-full object-cover"
                      imgStyle={{ borderRadius: '10px' }}
                    />
                  </div>

                  {/* Content */}
                  <div className="py-2">
                    <p
                      style={{
                        color: getStyleValue('card_style', 'card_title_heading', ''),
                      }}
                      className="text-[10px] sm:text-sm md:text-base font-semibold line-clamp-2"
                    >
                      {item?.card_heading}
                    </p>

                    {/* Price Section */}
                    <div className="flex items-center gap-2 mt-2 flex-wrap">
                      {item?.pricing_text && (
                        <span
                          className="rounded text-[10px] sm:text-xs md:text-sm px-1 py-[2px] font-semibold"
                          style={{
                            color: getStyleValue('card_style', 'card_pricing_text', ''),
                            background: getStyleValue('card_style', 'card_pricing_background', ''),
                          }}
                        >
                          {item?.pricing_text}
                        </span>
                      )}

                      {item?.old_pricing_text && (
                        <span
                          className="text-[#808080] text-[10px] sm:text-xs md:text-sm line-through"
                          style={{
                            color: getStyleValue('card_style', 'card_old_pricing', ''),
                          }}
                        >
                          {item?.old_pricing_text}
                        </span>
                      )}

                      {item?.discount_text && (
                        <span
                          className="text-[10px] sm:text-xs md:text-sm font-semibold"
                          style={{
                            color: getStyleValue('card_style', 'card_pricing_background', ''),
                          }}
                        >
                          {item?.discount_text}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default ProductFaceCardCarousel
